module.exports = __webpack_public_path__ + "img/criticalEvent.f2a32946.svg";